import { humanError, type ErrorScope } from "../api/client";

// Failure and loading are states of ONE block, never of the whole screen.
// The page keeps its heading, its tabs and the top navigation, so the reader
// can always move somewhere else instead of being stranded.
export function ErrorPanel({ error, onRetry, what = "this", scope = "item" }: { error: unknown; onRetry?: () => void; what?: string; scope?: ErrorScope }) {
  return (
    <section className="panel state-panel" role="alert">
      <p className="eyebrow">Could not load {what}</p>
      <h2>{humanError(error, scope)}</h2>
      <p className="panel-note">Nothing was changed. Your data is intact; only this request failed.</p>
      {onRetry ? (
        <div className="form-actions">
          <button className="primary-button compact" type="button" onClick={onRetry}><span>Try again</span><span aria-hidden="true">↻</span></button>
        </div>
      ) : null}
    </section>
  );
}

export function LoadingPanel({ message }: { message: string }) {
  return (
    <section className="panel state-panel" aria-live="polite" aria-busy="true">
      <p className="eyebrow">Loading</p>
      <h2>{message}</h2>
    </section>
  );
}
